import type { FormSectionLabel } from "~components/Form/FormSection";

type AddPersonFieldHelpers = {
  personDetailsFields: FormSectionLabel[];
  additionalDetailsFields: FormSectionLabel[];
  socialFields: FormSectionLabel[];
};

export const addPersonFieldHelpers: AddPersonFieldHelpers = {
  personDetailsFields: [
    {
      titleIntlKey: "name.local.full",
      descriptionIntlKey: "add.person.form.help.local.full.name",
    },
    {
      titleIntlKey: "name.latin.full",
      descriptionIntlKey: "add.person.form.help.latin.full.name",
    },
    {
      titleIntlKey: "abbreviated.name",
      descriptionIntlKey: "add.person.form.help.local.name.abbr",
    },
    {
      titleIntlKey: "date.of.birth",
      descriptionIntlKey: "add.person.form.help.dob",
    },
    {
      titleIntlKey: "nationality",
      descriptionIntlKey: "add.person.form.help.nationality",
    },
    {
      titleIntlKey: "gender",
      descriptionIntlKey: "add.person.form.help.gender",
    },
    {
      titleIntlKey: "status",
      descriptionIntlKey: "add.person.form.help.status",
    },
  ],
  additionalDetailsFields: [
    {
      titleIntlKey: "height",
      descriptionIntlKey: "add.person.form.help.height",
    },
    {
      titleIntlKey: "weight",
      descriptionIntlKey: "add.person.form.help.weight",
    },
    {
      titleIntlKey: "representing",
      descriptionIntlKey: "add.person.form.help.representing",
    },
  ],
  socialFields: [
    {
      titleIntlKey: "website",
      descriptionIntlKey: "add.person.form.help.social.website",
    },
    {
      titleIntlKey: "facebook",
      descriptionIntlKey: "add.person.form.help.social.facebook",
    },
    {
      titleIntlKey: "twitter",
      descriptionIntlKey: "add.person.form.help.social.twitter",
    },
    {
      titleIntlKey: "wikipedia",
      descriptionIntlKey: "add.person.form.help.social.wikipedia",
    },
    {
      titleIntlKey: "instagram",
      descriptionIntlKey: "add.person.form.help.social.instagram",
    },
  ],
};
